import { useOnboardingApi } from '@api/tutor-kanban/onboarding.hook'
import { parseFilterParams } from '@composables/hooks/tutor-kanban/filters/parse-filter-params'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const params = parseFilterParams(to.query)

  void useOnboardingApi({ params })
})
